function showpins() { mShowPagedResults() }
function GetPinData() { GetHotelPinData() }

function getPropChainKeys() {
    var s = "";
return s;
}


function typeinitResults() { }

function _srchst() {

    var b = _gsrchst(new Object())
    b.ChainKeys = getPropChainKeys();

    return b
}

